require('./sendExtractsViaMailStep1.scss');
// @vendors
const React = require('react');
const PropTypes = require('prop-types');
// @core
const { formatText } = require('core/i18n').i18n;
// @components
const PreContractualMailInfo = require('components/contactCenter/preContractualMailInfo/preContractualMailInfo');

// @helpers
const PersonalDataHelper = require('utilities/personalDataHelper');

class SendExtractsViaMailStep1 extends React.Component {
    render() {

        const { immProfile, immPrecontractualMail, requestProfile } = this.props;
        const profileError = immProfile.get('error');
        const clientEmail = PersonalDataHelper.getEmail(immProfile);

        return (
            <article className="send-extracts-via-mail-step-1">
                <header className="wizard_header">
                    <h1 className="wizard-step--vertical__title">
                        {formatText('sendExtractsViaMail-step1Title')}
                    </h1>
                </header>
                <section className="send-extracts-via-mail-step-1__content">
                    <PreContractualMailInfo
                        email={clientEmail}
                        requestProfile={requestProfile}
                        preContractualMail={immPrecontractualMail}
                        profileError={profileError}
                        showLegalText={false}
                        legalInfoText={true}
                        showMailSendButton={false}
                    />
                </section>
            </article>
        );
    }
}

SendExtractsViaMailStep1.propTypes = {
    immProfile: PropTypes.object.isRequired,
    immPrecontractualMail: PropTypes.object.isRequired,
    requestProfile: PropTypes.func.isRequired,
};

module.exports = SendExtractsViaMailStep1;
